export default "__VITE_ASSET__C8rd3VlP__"